import React from "react";

export const BrushIcon = ({ color = "#1E22FF", opacity = 1 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_7844_402)" opacity={opacity}>
        <path
          d="M6.00002 7.48127L8.51854 9.99979M5.31661 13.983C4.40538 14.8943 2.66671 14.6665 1.33337 14.6665C2.01677 13.3331 1.10555 11.5944 2.01677 10.6832C2.928 9.77198 4.40538 9.77198 5.31661 10.6832C6.22783 11.5944 6.22783 13.0718 5.31661 13.983ZM7.94778 10.6162L14.0392 4.03748C14.5757 3.45804 14.5584 2.55818 14 1.99979C13.4416 1.44139 12.5418 1.42409 11.9623 1.96062L5.3836 8.05202C5.04364 8.36679 4.87366 8.52418 4.77453 8.69204C4.5368 9.09455 4.52724 9.59215 4.74931 10.0035C4.84193 10.175 5.00573 10.3388 5.33334 10.6665C5.66095 10.9941 5.82475 11.1579 5.99629 11.2505C6.40764 11.4726 6.90525 11.463 7.30776 11.2253C7.47561 11.1261 7.633 10.9562 7.94778 10.6162Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7844_402">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
